import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockApiServices } from 'app/mock-api';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import { ToastrModule } from 'ngx-toastr';

import {PendingChangesGuard} from "../@fuse/guards/pending-changes/pending-changes.guard";
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { QuillModule } from 'ngx-quill';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';

const routerConfig: ExtraOptions = {
    preloadingStrategy       : PreloadAllModules,
    scrollPositionRestoration: 'enabled'
};
const config: SocketIoConfig = { url: environment.notificationUrl};

@NgModule({
    declarations: [
        AppComponent,

    ],
    imports     : [
        BrowserModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot(),
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,

        // 3rd party modules that require global configuration via forRoot
        MarkdownModule.forRoot({}),

        StoreModule.forRoot({}),
        EffectsModule.forRoot(),
        QuillModule.forRoot(),

        //socket
        SocketIoModule.forRoot(config)
        //Enable for Testing Only
        // StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode() }),
        // StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    ],
    bootstrap   : [
        AppComponent
    ],
    providers: [PendingChangesGuard],
})
export class AppModule
{
}
